import "./styles/_main.scss";
// #region Import
//Vue
import { createApp } from 'vue';
import AsyncComputed from "vue-async-computed";
import { createPinia } from 'pinia';
//Local
import Utils from "./shared/utils";
import ThePortal from './PortalHost';
import clickOutside from "./directives/click-outside";
import tooltip from "./directives/tooltip";
import sticky from "./directives/sticky";
import lazy from "./directives/lazyload";
import resize from "./directives/resize";
import move from "./directives/move";
import { TrackPositionPlugin } from "./directives/resize2";
// #endregion
// #region Utils
//New
const tUtils = new Utils();
//set
global.utils = tUtils;
window.utils = tUtils;
// #endregion
// #region App
//App
const app = createApp({
    template: '<g-app />',
});
const tPortal = new ThePortal(app);
// #endregion
// #region Global-Properties
app.config.globalProperties.$utils = tUtils;
app.config.globalProperties.$device = tUtils.device;
app.config.globalProperties.$appHost = tPortal;
app.config.globalProperties.$store = tPortal.store;
window.appHost = tPortal;
// #endregion
// #region Use
app.use(createPinia());
app.use(AsyncComputed);
app.use(TrackPositionPlugin);
// #endregion
// #region Register
//System
appHost.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
appHost.store.registerAll(require.context('./stores', true, /(?<!views)\.ts$/));
appHost.actions.registerAll(require.context('./actions', true, /(?<!modules)\.ts$/));
appHost.hub.registerAll(require.context('./hubs', true, /(?<!modules)\.ts$/));
//Directives
app.directive("click-outside", clickOutside);
app.directive("tooltip", tooltip);
app.directive("sticky", sticky);
app.directive("lazy-load", lazy);
app.directive("resize", resize);
app.directive("move", move);
// #endregion
// #region Startup
window.dispatchEvent(new Event('apphost-ready'));
// #endregion
